import { globalGet } from '@/app/modules/global/global';

/**
 * @deprecated legacy
 */
export namespace profileController {
  export const isEmailChangeRequestByB24 = () => {
    return globalGet<boolean>({
      path: 'bitrixEmailChange.modalEmailChangeBlocked.value',
    });
  };
}
